// extracted by mini-css-extract-plugin
export default {"productCarousel":"e0-z"};